import img1 from "../images/about/custom_recipes.png";
import img2 from "../images/about/book-1.jpg";
import img3 from "../images/about/natural-remedy-1.jpg";
import img5 from "../images/about/symptom-checker-2.jpg";

// What Sârv offers — the four product features, lifted out of
// components/about/Services.js when /mission was rebuilt.
//
// NOTE: the /services ROUTE renders components/services/Services.js, which is a
// different page about practitioners. components/about/Services.js was only ever
// mounted by the old Mission page and is now orphaned; this file is where its
// copy lives.
const ABOUT_SERVICES = [
  {
    imgSrc: img1,
    title: "Personalized Medicinal Plants Recommendations",
    summary:
      "Utilizing advanced technology, we analyze your physical characteristics, such as age, gender, and existing health conditions, to provide personalized recommendations for natural remedies. This tailored approach ensures you receive the most suitable natural solutions for your unique health needs.",
  },
  {
    imgSrc: img5,
    title: "Symptom Checker",
    summary:
      "Our symptom checker guides you through a series of questions to understand your health concerns and then suggests holistic remedies, such as medicinal plants. This focused approach provides you with natural healthcare solutions tailored to your specific symptoms.",
  },
  {
    imgSrc: img3,
    title: "Customized Herbal Recipes",
    summary:
      "Offering hundreds of herbal recipes tailored to specific health conditions, this feature allows you to explore and utilize natural remedies in practical, everyday applications. From teas to tinctures, these recipes provide accessible and natural ways to enhance health and well-being.",
  },
  {
    imgSrc: img2,
    title: "Educational Resource on Medicinal Herbs",
    summary:
      "The platform serves as a comprehensive educational resource, offering detailed information on various medicinal herbs, including their properties, benefits, and historical uses. This feature empowers you to learn about natural healthcare and make informed decisions about your wellness journey.",
  },
];

export default ABOUT_SERVICES;
